import { useContext, useEffect, useState } from 'react'
import LinkWithStatus from '../../common/LinkWithStatus'
import { ModalBody } from '../../common/Modal'
import { NavContext } from '../../../context/global_context'
import { getRequest, postRequest } from '../../../services/base'
import { Sad } from '@styled-icons/boxicons-solid'
import { PromotedBranchContext } from '../context/context'
import { useSearchParams } from 'react-router-dom'
import SelectInput from '../../common/SelectInput'
import CheckBox from '../../common/CheckBox'

const SelectVersionModal = ({ vehicle, setSelectTracerVersion }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [state, dispatch] = useContext(PromotedBranchContext)
  const [selectedDataVersion, setSelectedDataVersion] = useState(null)

  const [versionsData, setVersionsData] = useState({})
  const [navState, navDispatch] = useContext(NavContext)
  const [dataError, setDataError] = useState(null)

  useEffect(() => {
    getTracerVersions()
  }, [vehicle])

  const getTracerVersions = async () => {
    setDataError(null)
    navDispatch({
      type: 'loader',
      data: {
        caption: `Loading Versions...`,
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/dtc_validation/tracer-data-version/${vehicle}/?data_version=${searchParams.get('data_version') ? searchParams.get('data_version') : ''}`
    )
    if (
      !res?.status ||
      (!res?.data?.data_version && !res?.data?.app_version) ||
      res?.data?.data_version === state?.data?.branch
    ) {
      setDataError(res.data)
      setVersionsData({})
    } else {
      setVersionsData(res.data)
    }

    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const initiateTracerPreview = async () => {
    if (selectedDataVersion && versionsData.app_version) {
      if (
        window.confirm(
          `Are you sure want to run tracer preview for selected make model`
        ) === true
      ) {
        navDispatch({
          type: 'loader',
          data: {
            caption: 'We are initiating Tracer Preview ...',
            showLoader: true,
          },
          notification: {},
        })

        let payload = {
          tracer_version: versionsData.app_version,
          data_version: selectedDataVersion,
        }
        let res = await postRequest(
          `/api/tracer/preview/start/?vehicle=${vehicle}`,
          payload
        )
        if (res?.status) {
          dispatch({ type: `reset_tracer_preview` })
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'success',
              msg: `Preview Successfully initiated`,
            },
          })
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: `Something went wrong please try again.`,
            },
          })
        }
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: `Please select version.`,
        },
      })
    }
  }

  return (
    <ModalBody>
      <div
        className="flex items-center justify-center w-full"
        style={{ height: '35vh' }}
      >
        <div className="w-1/2">
          {dataError ? (
            <div className="text-center text-white">
              <Sad size="3rem" color="white" />
              <div className="">
                Version is not availble, Please Select another make model
              </div>
            </div>
          ) : (
            <div className="text-white">
              <div className="py-1">
                <div className="flex justify-center">
                  App Version : {versionsData.app_version}
                </div>
                <div> </div>
              </div>
              <div className="w-full flex justify-center items-center">
                <div className="flex justify-center">Data Version : </div>

                {state?.data?.branch != versionsData.data_version &&
                  versionsData.data_version != '' && (
                    <span className="flex items-center">
                      <div className="px-3">
                        <CheckBox
                          name="data_version"
                          value={
                            selectedDataVersion ===
                            `v${versionsData.data_version}`
                          }
                          checked={
                            selectedDataVersion ===
                            `v${versionsData.data_version}`
                          }
                          onChange={(e) =>
                            setSelectedDataVersion(
                              `v${versionsData.data_version}`
                            )
                          }
                        />
                      </div>
                      <span>v{versionsData.data_version}</span>
                    </span>
                  )}
                {searchParams.get('data_version') !== state?.data?.branch && (
                  <span className="flex items-center">
                    <div className="px-3">
                      <CheckBox
                        name="data_version"
                        value={selectedDataVersion === state?.data?.branch}
                        checked={selectedDataVersion === state?.data?.branch}
                        onChange={(e) =>
                          setSelectedDataVersion(state?.data?.branch)
                        }
                      />
                    </div>
                    <span>{state?.data?.branch}</span>
                  </span>
                )}
              </div>
            </div>
          )}

          <div className="flex justify-center py-5 gap-4">
            <LinkWithStatus
              href={`/administration/tracer_preview/tracer-data-version`}
              className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
              title="Back"
              onClickFunc={() => {
                setSelectTracerVersion(false)
              }}
            />
            {!dataError && (
              <LinkWithStatus
                href={`/administration/tracer_preview/tracer-data-version`}
                className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
                title="Initiate Preview"
                onClickFunc={() => {
                  initiateTracerPreview()
                }}
              />
            )}
          </div>
        </div>
      </div>
    </ModalBody>
  )
}

export default SelectVersionModal
